module.exports = __webpack_public_path__ + "static/media/10.eead5530.png";